import script from "./CartDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./CartDrawer.vue?vue&type=script&setup=true&lang=js"

import "./CartDrawer.vue?vue&type=style&index=0&id=5c7e4076&scoped=true&lang=css"
import "./CartDrawer.vue?vue&type=style&index=1&id=5c7e4076&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.44_vue@3.5.44_webpack@5.112.2_postcss@8.5.32_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c7e4076"]])

export default __exports__